import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import styled from "styled-components";
import PropTypes from "prop-types";
import { animated } from "react-spring";
import { CloseOutlined } from "@ant-design/icons";
import "./styles.css";

const Portal = ({ children, toggle, open }) => {
  const modalRoot = document.getElementById("modal-root");
  const el = document.createElement("div");

  useEffect(() => {
    modalRoot.appendChild(el);
    return () => modalRoot.contains(el) && modalRoot.removeChild(el);
  }, [el, modalRoot]);

  useEffect(() => {
    !open && modalRoot.removeChild(el);
  }, [el, modalRoot, open]);

  useEffect(() => {
    function outsideClick({ target }) {
      return open && el && !el.contains(target) && toggle();
    }
    document.addEventListener("click", outsideClick, false);
    return () => document.removeEventListener("click", outsideClick, false);
  }, [el, modalRoot, toggle, open]);

  return createPortal(children, el);
};
const Modal = ({ children, toggle, open, style }) => (
  <Portal toggle={toggle} open={open}>
    <ModalWrapper style={style} className="modal-wrapper">
      <>
        <div className="menu-close">
          <CloseOutlined type="close" style={{ cursor: "pointer" }} onClick={toggle} />
        </div>
        {children}
      </>
    </ModalWrapper>
  </Portal>
);
export default Modal;
Modal.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.objectOf(PropTypes.object),
    PropTypes.object,
    PropTypes.array,
  ]),
  toggle: PropTypes.func.isRequired,
};
const ModalWrapper = styled(animated.div)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 25px;
  background: white;
  border-radius: 5px;
  cursor: pointer;
  box-shadow: 0px 10px 10px -5px rgba(0, 0, 0, 0.05);
  will-change: width, height;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow: auto;
`;
